import 'select2';
import {registerHtmlHook} from "../utils/htmlHooks";

const select2Options = {
    theme: 'bootstrap-5',
    minimumResultsForSearch: 10
};

(function ($) {
    $.initSelect2 = function (ele = null) {
        (ele ?? $('select.is-select').not($('.is-swiper select.is-select')).not('.is-select-disable')).select2(select2Options);
    };
}(jQuery));

$(document).ready(() => {
    $.initSelect2();
});

$(window).resize(() => {
    $.initSelect2();
});

registerHtmlHook((container) => $(container).find('select.is-select').not($('.is-swiper select.is-select')).not('.is-select-disable').select2(select2Options));
